
import Bold from '@tiptap/extension-bold'

export default Bold.extend({
  addOptions() {
    return {
      ...this.parent?.(),
      button: null,
    }
  },
})
